//#region types
import { StyleEnums } from "models/enums";
import { WintSuperkollAPIModelQualifiedShareDividend } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { QualifiedShareDividendTopCardContentProps } from "models/propTypes/qualifiedShareDividendsPropTypes";
//#endregion
//#region components
import { EntityTopCardContent } from "components/common";
import useQualifiedShareDividendSnoozeAction from "../actions/useQualifiedShareDividendSnoozeAction";
import { useQualifiedShareDividendsService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const QualifiedShareDividendTopCardContent: React.FC<QualifiedShareDividendTopCardContentProps> = (props) => {
  const qualifiedShareDividendsService = useQualifiedShareDividendsService();
  const { qualifiedShareDividend, statusIndicatorDisplayType } = props;

  const title = LocalizationHelperInstance.getFormattedMessage(`Todos.K10Form`);
  const subTitle = qualifiedShareDividendsService.getStateText(qualifiedShareDividend.state);

  const descriptionHeadingOne = `${LocalizationHelperInstance.getFormattedMessage(
    TranslationKeys.QualifiedShareDividends.FinancialYear
  )} ${qualifiedShareDividend.incomeYear}`;

  const descriptionHeadingTwo = qualifiedShareDividend.companyName ?? "";

  const snoozeAction = useQualifiedShareDividendSnoozeAction(qualifiedShareDividend!.id ?? 0, props.reloadHandler);

  if (
    qualifiedShareDividend.state ===
    WintSuperkollAPIModelQualifiedShareDividend.QualifiedShareDividendState.AwaitingApproval
  ) {
    return (
      <EntityTopCardContent
        title={title}
        subTitle={subTitle}
        descriptionHeadingOne={descriptionHeadingOne}
        descriptionHeadingTwo={descriptionHeadingTwo}
        footerText={`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Latest)}: ${
          qualifiedShareDividend ? LocalizationHelperInstance.getFormattedDate(qualifiedShareDividend.dueDate) : "."
        }`}
        statusIndicatorDisplayType={statusIndicatorDisplayType ?? StyleEnums.DisplayType.Info}
        quickActions={[snoozeAction]}
      />
    );
  } else {
    return (
      <EntityTopCardContent
        title={title}
        subTitle={subTitle}
        descriptionHeadingOne={descriptionHeadingOne}
        descriptionHeadingTwo={descriptionHeadingTwo}
        footerText={`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Approved)}: ${
          qualifiedShareDividend ? LocalizationHelperInstance.getFormattedDate(qualifiedShareDividend.updatedDate) : "."
        }`}
        statusIndicatorDisplayType={statusIndicatorDisplayType ?? StyleEnums.DisplayType.Success}
      />
    );
  }
};

export default QualifiedShareDividendTopCardContent;
